import { FieldArray, FormikState } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomTariffRule as CustomTariffRuleType } from 'screens/GroupsAndPolicies/types';
import { Button, Divider } from 'semantic';
import { FormController } from '../FormController';
import { CustomTariffRuleFormFields } from './CustomTariffRuleFormFields';
import { CustomTariffRulePreview } from './CustomTariffRulePreview';
import { customTariffRuleSchema } from '../validation';

type Props = {
  values?: FormikState<CustomTariffRuleType[]>['values'];
};

export const CustomTariffRulesFormFields = (props: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <FieldArray name="customTariffRules">
        {({ push, remove, replace }) => {
          return (
            <>
              {props?.values?.map((customTariffRule, index) => {
                return (
                  <React.Fragment key={index}>
                    <FormController
                      values={customTariffRule}
                      onSubmit={(values) => {
                        replace(index, { ...values, __initial: undefined });
                      }}
                      onRemove={() => remove(index)}
                      validationSchema={customTariffRuleSchema}
                      formComponent={CustomTariffRuleFormFields}
                      previewComponent={CustomTariffRulePreview}
                      openInEditMode={(customTariffRule as any).__initial}
                      removeOnCancel={(customTariffRule as any).__initial}
                    />
                    <Divider hidden />
                  </React.Fragment>
                );
              })}
              {!props?.values?.length && (
                <p>
                  {t(
                    'chargingPolicy.pricing.noCustomTariffRules',
                    'There are no custom tariff rules to display.'
                  )}
                </p>
              )}
              <Button
                basic
                onClick={() => push({ __initial: true })}
                icon="plus"
                content={t(
                  'chargingPolicy.pricing.addCustomTariffRule',
                  'Add Custom Tariff Rule'
                )}
              />
            </>
          );
        }}
      </FieldArray>
    </>
  );
};
